import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class StationService {
  url = environment.url;
  AllStationsTimeZones = []
  constructor(public http: HttpClient) { }

  getStations() {
    return this.http.get(`${this.url}` + '/station/getAllStations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting stations'))),
    );
  }

  getNonOutSourcedStations() {
    return this.http.get(`${this.url}` + '/station/getNonOutsourceStations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting stations'))),
    );
  }



  getOutsourceStations() {
    return this.http.get(`${this.url}` + '/station/getOutsourceStations').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting outsource stations'))),
    );
  }

  getAllStationsTimeZones() {
    return this.http.get(`${this.url}` + '/station/timezones').pipe(tap(res => {
      this.AllStationsTimeZones = res['result']
    }),
      catchError(err => throwError(new Error('Issue in getting stations time zones'))),
    );
  }

  getTimezonesForStations() {
    if (this.AllStationsTimeZones != null) {
      return this.AllStationsTimeZones
    } else {
      this.getAllStationsTimeZones().subscribe(res => {
        this.AllStationsTimeZones = res["result"]
        return this.AllStationsTimeZones
      })
    }
  }

  convertTime(date, stationcode) {
    let station;
    if (this.AllStationsTimeZones != null) {
      station = this.AllStationsTimeZones.filter(element => element.code === stationcode)
      if (station[0].isAdd) {
        return moment(date).add(station[0].value, 'hours');
      } else {

        return moment(date).subtract(station[0].value, 'hours');
      }
    }
  }

}
